import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ImageCacheService } from '../helpers/image-cache.service';
import { environment } from '../../../src/environment/environment';

/**
 * Pipe to cache images and return blob URLs
 * Usage: <img [src]="imageUrl | cachedImage | async" />
 */
@Pipe({
  name: 'cachedImage',
  standalone: true,
})
export class CachedImagePipe implements PipeTransform {
  private readonly imageCache = inject(ImageCacheService);
  private static cleanupStarted = false;
  private static readonly apiHost = (() => {
    try {
      return new URL(environment.API_URL).host;
    } catch {
      return '';
    }
  })();

  constructor() {
    // Start auto cleanup only once
    if (!CachedImagePipe.cleanupStarted) {
      this.imageCache.startAutoCleanup();
      CachedImagePipe.cleanupStarted = true;
    }
  }

  transform(url: string | null | undefined): Observable<string> {
    if (!url) {
      return of('');
    }

    // Only cache images from current API host
    if (!this.isApiHost(url)) {
      return of(url);
    }

    return this.imageCache.getImage(url);
  }

  private isApiHost(url: string): boolean {
    if (!CachedImagePipe.apiHost) {
      return false;
    }

    try {
      return new URL(url, typeof window !== 'undefined' ? window.location.origin : undefined).host === CachedImagePipe.apiHost;
    } catch {
      return false;
    }
  }
}
